import React, { useState } from 'react';
import ForgotPassword from './ForgotPassword'
import OTP from './OTP'
import Password from './Password'
import { useSelector } from 'react-redux';
import ToastError from '../../dialog/toastError'
import Info from '../../dialog/GeneralDialog'
import Error from '../../dialog/dialogError'
import Success from '../../dialog/dialogSuccess'


const Login = () => {

  const step = useSelector(state => state.auth.step);
  const dialog = useSelector(state => state.auth.dialog);

  const handleStep = (stepper) =>{
    switch (stepper) {
        case 0:
            return <ForgotPassword />
        case 1:
            return <OTP />
        case 2:
            return <Password />
        default:
        return '';
    }
  }


  const handleError = (dialog) =>{
    if (dialog && dialog.style) {
      switch (dialog.style) {
        case 'inline':
          return <ToastError />
        case 'toast':
          return <ToastError />
        case 'none':
          return <ToastError />
        case 'overlay':
          return <Info />
        case 'dialog-error':
          return <Error />
        case 'success':
          return <Success />
        default:
          return '';
      }    
    }
  }

  return (
    <>
      {handleStep(step)}
      {handleError(dialog)}
    </>
  );
};

export default Login;
